import { Epic } from 'interfaces/middleware'
import { COMPLETE_FUTURE_LAYER, completeFutureLayerActionCreator } from 'components/features/future/actions'
import { mergeMap } from 'rxjs/operators'
import { empty, of } from 'rxjs'
import { layerSelector } from 'components/features/future/selectors'
import { COMPLETE_LAYER_URL } from 'interfaces/ajax'
import { filterRequestOfType } from 'rxOperators/filterRequestOfType'
import { normalizeFutureResponse } from 'components/features/future/helpers'
import { catchAjaxSafe } from 'rxOperators/catchSafe'
import { killAllFloatingPanesActionCreator, modifyFloatingPaneActionCreator } from 'actions/floatingPanesActions'

export const completeEpic: Epic = (action$, store, { post }) =>
  action$.pipe(
    filterRequestOfType(COMPLETE_FUTURE_LAYER, 'request'),
    mergeMap((action) => {
      const { params } = action.payload
      const state = store.getState()
      const { uid, addIncomeChangeEvent, ...body } = params
      const layer = layerSelector(state, params)

      if (!layer) {
        return empty()
      }

      const { slug } = layer

      const url = {
        url: COMPLETE_LAYER_URL,
        params: {
          slug,
          uid,
        },
      }

      return post(url, { body }).pipe(
        mergeMap(({ response }) => {
          return of(completeFutureLayerActionCreator.success(params, normalizeFutureResponse(response)))
        }),
        catchAjaxSafe((error) => {
          return of(completeFutureLayerActionCreator.fail(params, error.status))
        })
      )
    }),
  )

export const completeSuccessEpic: Epic = (action$) =>
  action$.pipe(
    filterRequestOfType(COMPLETE_FUTURE_LAYER, 'success'),
    mergeMap(({ payload }) => {
      if (!payload.params.addIncomeChangeEvent) {
        return empty()
      }

      return of(
        killAllFloatingPanesActionCreator(),
        modifyFloatingPaneActionCreator('future', {
          mode: 'layer-details',
          slug: 'income_change',
        }),
      )
    })
  )
